import { render, staticRenderFns } from "./CatalogView.vue?vue&type=template&id=1f725a05&scoped=true&"
import script from "./CatalogView.vue?vue&type=script&lang=js&"
export * from "./CatalogView.vue?vue&type=script&lang=js&"
import style0 from "./CatalogView.vue?vue&type=style&index=0&id=1f725a05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f725a05",
  null
  
)

export default component.exports